<template>
  <div class="payback-page">
    <div class="back-to-home">
      <router-link :to="{ name: 'earlyPaymentList' }" >
        <img src="@/assets/img/left-arrow.svg" alt="Back home" />
        <img src="@/assets/img/left-arrow-red.svg" alt="Back home" />
        <span>Trở về Tính toán trả nợ sớm</span>
      </router-link>
    </div>
    <h2 class="table-title">
      Dự tính số tiền trả nợ sớm
    </h2>
    <div class="contract-detail">
      <div
        class="flex flex-col-reverse xl:flex-row contract-detail-left"
      >
        <div class="w-full lg:w-full xl:w-1/2">
          <p
            class="contract-number hidden xl:block"
          >
            HỢP ĐỒNG SỐ {{contractNo}}
          </p>

          <div class="payback-detail-wrap">
            <ul class="payback-detail">
              <li class="block md:flex">
                <div class="flex flex-col">
                  <p>
                    SỐ TIỀN VAY BAN ĐẦU
                  </p>
                  <p
                    class="payback-value"
                  >
                    {{Number(earlyPayment.AmountFinanced).toLocaleString()}} VND
                  </p>
                </div>
                <div class="flex flex-col">
                  <p>DƯ NỢ CÒN LẠI</p>
                  <p
                    class="payback-value"
                  >
                    {{Number(earlyPayment.OutstandingBalance).toLocaleString()}} VND
                  </p>
                </div>
              </li>
              <li class="block md:flex">
                <div class="flex flex-col">
                  <p>LÃI SUẤT VAY</p>
                  <p
                    class="payback-value"
                  >
                    {{earlyPayment.InterestRate}}%
                  </p>
                </div>
                <div class="flex flex-col" v-if="earlyPayment.Is5050Contract === false">
                  <p>
                    LÃI SUẤT PHẠT TRẢ
                    SỚM
                    <i name="tooltip-2" class="vlicon icon-info-circled vl-info-icon" v-if="earlyPayment.InterestFormula !== null && Number(earlyPayment.InterestRateEarly) > 0"></i>
                  </p>
                  <tippy  v-if="earlyPayment.InterestFormula !== null && Number(earlyPayment.InterestRateEarly) > 0" to="tooltip-2" interactive placement="bottom" theme="vl" trigger="mouseenter focus" arrow>
                    <div id="tooltip" role="tooltip">
                      <p class="custom-tooltip_title">CÔNG THỨC TÍNH:</p>
                      <span>
                          = {{earlyPayment.InterestFormula}}
                      </span>
                    </div>
                  </tippy>
                  <p
                    class="payback-value"
                  >
                    {{earlyPayment.InterestRateEarly}}%
                  </p>
                </div>
              </li>
              <li class="block md:flex">
                <div class="flex flex-col">
                  <p>
                    NGÀY THANH TOÁN TIẾP
                    THEO
                  </p>
                  <p
                    class="payback-value"
                  >
                    {{ earlyPayment.NextDueDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div
          class="w-full lg:full xl:w-1/2 text-center"
        >
          <div class="contract-product">
            <img :src="'data:image/jpeg;base64,' + earlyPayment.Car.Image" alt="Toyota"/>
            <div class="car-number">
              {{earlyPayment.Car.PlateNo}}
            </div>
          </div>
        </div>
        <p class="contract-number block xl:hidden">
          HỢP ĐỒNG SỐ {{contractNo}}
        </p>
      </div>
      <!-- Bang tra no -->
      <div class="w-full">
        <div class="payback-calculator">
          <h3 class="calculator-title flex items-center" >
            <i class="icon-calc"></i>
            <span>CHI TIẾT SỐ TIỀN TRẢ NỢ SỚM
              <span class="inline-block xl:hidden" >(TẠM TÍNH)</span>
            </span>
            <div class="ui-tag hidden xl:block">
              TẠM TÍNH
            </div>
          </h3>
          <div class="flex">
            <div
              class="w-full lg:w-full xl:w-2/3"
            >
              <div
                class="payment-options-wrap"
              >
                <p
                  class="info-text block lg:hidden"
                >
                  Chạm vào biểu tượng
                  <i
                    class="vlicon icon-info-circled vl-info-icon"
                  ></i>
                  để xem công thức tính
                </p>
                <div
                  class="payment-option-tabs-control block xl:flex"
                >
                  <div>
                    <input
                      id="opt-in"
                      type="radio"
                      name="radio"
                      value="all"
                      v-model="picked"
                      checked
                    />
                    <label for="opt-in"
                    >THANH LÝ</label
                    >
                  </div>
                  <div>
                    <input
                      id="opt-in2"
                      type="radio"
                      name="radio"
                      value="part"
                      v-model="picked"
                    />
                    <label for="opt-in2"
                    >GIẢM
                      GỐC</label
                    >
                  </div>
                </div>
                <div
                  class="payment-options"
                >
                  <div v-if="picked === 'all'" class="option1">
                    <div v-if="earlyPayment.Is5050Contract === true" class="payback-rows" >
                      <div class="payback-label">Lãi tính đến ngày</div>
                      <div class="payback-input">
                        <div class="custom-date-picker">
                          <datepicker v-model="interestDate" format="dd MMMM yyyy" :calendar-button="true" calendar-button-icon="vlicon icon-calendar-check-o" :language="vi"></datepicker>
                        </div>
                      </div>
                    </div>
                    <div class="payback-rows" v-if="earlyPayment.Is5050Contract === false">
                      <div class="payback-label">Lãi phải trả</div>
                      <div class="payback-input">
                        {{Number(paymentAll.Interest).toLocaleString()}}
                        VND
                        <div class="payback-tooltip">
                          <i v-show="paymentAll.Interest"
                            name="tooltip-5"
                            class="vlicon icon-info-circled vl-info-icon"
                          ></i>
                          <tippy to="tooltip-5" interactive placement="bottom" theme="vl" trigger="mouseenter focus" arrow>
                            <div id="tooltip-5" role="tooltip">
                              <p class="custom-tooltip_title">CÔNG THỨC TÍNH:</p>
                              <span>
                                = {{paymentAll.InterestFormula}}
                              </span>
                            </div>
                          </tippy>
                        </div>
                      </div>
                    </div>
                    <div class="payback-rows">
                      <div class="payback-label">{{earlyPayment.Is5050Contract ? 'Lãi phải trả' : 'Phạt trả nợ sớm'}}</div>
                      <div class="payback-input">
                        {{Number(paymentAll.InterestAmount).toLocaleString()}}
                        VND
                        <div class="payback-tooltip">
                          <i name="tooltip-4" class="vlicon icon-info-circled vl-info-icon"></i>
                          <tippy to="tooltip-4" interactive placement="bottom" theme="vl" trigger="mouseenter focus" arrow>
                            <div id="tooltip-4" role="tooltip">
                              <p class="custom-tooltip_title">CÔNG THỨC TÍNH:</p>
                              <span>
                                = {{paymentAll.InterestAmountFormula}}
                              </span>
                            </div>
                          </tippy>
                        </div>
                      </div>
                    </div>
                    <div class="payback-rows">
                      <div class="payback-label">Phạt trễ hạn</div>
                      <div class="payback-input">
                        {{Number(paymentAll.LateFee).toLocaleString()}} VND
                      </div>
                    </div>
                    <div class="payback-rows">
                      <div class="payback-label">Tiền dư trên hợp đồng</div>
                      <div class="payback-input">
                        {{Number(paymentAll.ResidualAmount).toLocaleString()}} VND
                      </div>
                    </div>
                  </div>
                  <div v-if="picked === 'part'" class="option2">
                    <div v-if="earlyPayment.Is5050Contract === true" class="payback-rows">
                      <div class="payback-label">Lãi tính đến ngày</div>
                      <div class="payback-input">
                        <div class="custom-date-picker">
                          <datepicker v-model="interestDatePart" format="dd MMMM yyyy" :calendar-button="true" calendar-button-icon="vlicon icon-calendar-check-o" :language="vi"></datepicker>
                        </div>
                      </div>
                    </div>
                    <div class="payback-rows">
                      <div class="payback-label">Số tiền muốn trả sớm</div>
                      <div class="payback-input">
                        <input type="text" v-model="tmpAmount"/>
                        <div class="payback-tooltip">
                          <i name="tooltip-1" class="vlicon icon-info-circled vl-info-icon"></i>
                          <tippy to="tooltip-1" interactive placement="bottom" theme="vl" trigger="mouseenter focus" arrow>
                            <div id="tooltip-1" role="tooltip">
                              <p class="custom-tooltip_title">LƯU Ý</p>
                              <ul v-if="earlyPayment.Is5050Contract === true">
                                <li>
                                  Số tiền giảm gốc tối thiểu phải là 30 triệu VND
                                </li>
                              </ul>
                              <ul v-else>
                                <li>
                                  Số tiền này chưa bao gồm tiền góp kỳ
                                  <b>{{ earlyPayment.NextDueDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}</b>.
                                </li>
                                <li>
                                  Số tiền giảm gốc tối thiểu = 2*Gốc hàng tháng
                                  Số tiền giảm gốc tối đa = dư nợ còn lại
                                </li>
                                <li>
                                  Ngày trừ gốc trả sớm là Ngày đến hạn thanh toán tiếp theo
                                  <b>{{ earlyPayment.NextDueDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}</b>. Thời hạn hợp đồng sẽ được rút ngắn
                                  lại
                                </li>
                                <li>
                                  Lịch thanh toán mới sẽ được áp dụng kể từ kỳ thanh toán
                                  <b>{{ earlyPayment.NextPeriodDate | dateParse('YYYY-MM-DD') | dateFormat('DD/MM/YYYY') }}</b>
                                </li>
                              </ul>
                            </div>
                          </tippy>
                        </div>
                        <!--<div class="payback-placeholder">
                          <small>Từ <strong>2,000,000 VND</strong> tới <strong>2,500,000,000</strong> VND</small>
                        </div>-->
                      </div>
                      <span style="color: red; text-align: right; width: 100%; padding-right: 17px" v-if="paymentAmountError && earlyPayment.Is5050Contract === true">* Số tiền thanh toán không hợp lệ</span>
                    </div>
                    <div class="payback-rows" >
                      <div class="payback-label"></div>
                      <div class="payback-input">
                        <button class="payback-button" @click="calculateEarlyPaymentPrincipalReduce" :disabled="isRequest || (paymentAmountError && earlyPayment.Is5050Contract === true)" >
                          <vue-element-loading :active="isRequest"/>TÍNH TOÁN TRẢ NỢ SỚM</button>
                      </div>
                    </div>
                    <div class="payback-rows payback-rows--inline">
                      <div class="payback-label">{{earlyPayment.Is5050Contract ? 'Lãi phải trả' : 'Phạt trả nợ sớm'}}</div>
                      <div class="payback-input">
                        {{Number(paymentPart.InterestAmount).toLocaleString()}} VND
                        <div v-show="paymentPart.InterestAmountFormula" class="payback-tooltip">
                          <i name="tooltip-6" class="vlicon icon-info-circled vl-info-icon"></i>
                        </div>
                      </div>
                      <tippy to="tooltip-6" interactive placement="bottom" theme="vl" trigger="mouseenter focus" arrow>
                        <div id="tooltip-6" role="tooltip">
                          <p class="custom-tooltip_title">CÔNG THỨC TÍNH:</p>
                          <span>
                          = {{paymentPart.InterestAmountFormula}}
                        </span>
                        </div>
                      </tippy>
                    </div>
                  </div>
                </div>
                <div
                  class="option-text-highlight block lg:flex justify-between"
                >
                  <div class="payback-label">TỔNG SỐ TIỀN CẦN THANH TOÁN</div>
                  <div class="payback-input">
                    {{ picked === 'all' ? Number(paymentAll.TotalAllPaymentEarly).toLocaleString() :Number(paymentPart.TotalAllPaymentEarly).toLocaleString()}} VND
                    <div class="payback-tooltip">
                      <i name="tooltip-3" v-show="picked === 'all'" class="vlicon icon-info-circled vl-info-icon"></i>
                      <tippy to="tooltip-3" interactive placement="bottom" theme="vl" trigger="mouseenter focus" arrow>
                        <div id="tooltip-3" role="tooltip">
                          <p class="custom-tooltip_title">CÔNG THỨC TÍNH:</p>
                          <span>
                            = {{paymentAll.TotalPaymentFormula}}
                          </span>
                        </div>
                      </tippy>
                    </div>
                  </div>
                </div>

                <p
                  class="info-text hidden lg:block"
                >
                  Đặt con chuột vào biểu
                  tượng
                  <i
                    class="vlicon icon-info-circled vl-info-icon"
                  ></i>
                  để xem công thức tính
                </p>
              </div>
            </div>
            <div
              class="hidden xl:block w-full lg:w-full xl:w-1/3"
            >
              <div v-if="picked === 'all'" class="contract-note">
                <h5 v-html="paymentAllNote[0].Title">
                </h5>
                <div
                  v-html="paymentAllNote[0].Content"
                >
                </div>
                <div
                  class="contract-note-bottom"
                >
                  <p
                    class="contract-note-title"
                    v-html="paymentAllNote[1].Title"
                  >
                    Lưu ý về yêu cầu thanh lý
                  </p>
                  <div v-html="paymentAllNote[1].Content"></div>
                </div>
              </div>
              <div v-if="picked === 'part'" class="contract-note">
                <h5 v-html="paymentPartNote[0].Title">
                </h5>
                <div
                  v-html="paymentPartNote[0].Content"
                >
                </div>
                <div
                  class="contract-note-bottom"
                >
                  <p
                    class="contract-note-title"
                    v-html="paymentPartNote[1].Title"
                  >
                  </p>
                  <div v-html="paymentPartNote[1].Content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="mobile-payment-guide block xl:hidden"
        >
          <button
            id="mobileModal"
            class="view-payment-guide-button"
            @click="isShownModal = true"
          >
            XEM HƯỚNG DẪN THANH TOÁN
          </button>
        </div>
      </div>
    </div>
    <UiModal closeOnOverlay :show.sync="isShownModal">
      <div
        class="modal-scroll bg-white w-11/12 md:max-w-md mx-auto shadow-lg z-50 payment-guide-modal"
      >
        <div class="modal-content text-left">
          <!--Title-->
          <div class="modal-header bg-danger text-white">
            <div class="modal-title" >
              Thanh toán hợp đồng trả góp
              <div class="modal-close" @click="isShownModal = false">
                <img src="@/assets/img/icon-close-white.svg" alt="Close" />
              </div>
            </div>
          </div>
          <!--Body-->
          <div class="modal-body" id="modalScroll">
            <div v-if="picked === 'all'" class="contract-note">
                <div v-html="paymentAllNote[0].Content">
                </div>
              <div class="contract-note-bottom">
                <p class="contract-note-title"  v-html="paymentAllNote[1].Title">
                </p>
                <div v-html="paymentAllNote[1].Content"></div>
              </div>
            </div>
            <div v-if="picked === 'part'" class="contract-note">
              <div v-html="paymentPartNote[0].Content">
              </div>
              <div class="contract-note-bottom">
                <p class="contract-note-title" v-html="paymentPartNote[1].Title">
                </p>
                <div v-html="paymentPartNote[1].Content"></div>
              </div>
            </div>
          </div>
          <!--Footer-->
          <div class="modal-footer">
            <button @click="isShownModal = false" class="modal-close px-4 p-3">
              Đóng
            </button>
          </div>
        </div>
      </div>
    </UiModal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { EarlyPaymentService } from '@/services/earlyPayment.service'
import UiModal from '@/components/UiModal'
import Datepicker from 'vuejs-datepicker'
import VueTippy, { TippyComponent } from 'vue-tippy'
import { vi } from 'vuejs-datepicker/dist/locale'
Vue.use(VueTippy)

export default {
  name: 'EarlyPaymentDetail',
  components: {
    tippy: TippyComponent,
    Datepicker,
    UiModal
  },
  data () {
    return {
      vi: vi,
      contractNo: this.$route.params.contractNo,
      picked: 'all',
      interestDate: new Date(),
      interestDatePart: new Date(),
      tmpAmount: 0,
      paymentAll: {
        OutstandingBalance: 0,
        InterestAmount: 0,
        InterestAmountFormula: '',
        Interest: 0,
        InterestFormula: '',
        LateFee: 0,
        ResidualAmount: 0,
        TotalAllPaymentEarly: 0,
        TotalPaymentFormula: ''
      },
      paymentAllNote: [],
      paymentPart: {
        InterestAmount: 0,
        InterestAmountFormula: '',
        TotalAllPaymentEarly: 0
      },
      paymentPartNote: [],
      isRequest: false,
      isShownModal: false
    }
  },
  watch: {
    interestDate: function (val) {
      this.calculateEarlyPayment(val.toISOString())
    },
    tmpAmount: function (newValue) {
      const result = newValue.replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' VND'
      // eslint-disable-next-line no-return-assign
      this.$nextTick(() => this.tmpAmount = result)
    }
  },
  computed: {
    ...mapState('earlyPayment', {
      earlyPayment: 'currentEarlyPayment'
    }),
    amount () {
      if (this.tmpAmount) {
        return parseFloat(String(this.tmpAmount).replace(/,/g, ''))
      }
      return 0
    },
    paymentAmountError () {
      console.log(this.amount)
      return Number(this.amount) < 30000000 || isNaN(parseFloat(this.amount)) || Number(this.amount) <= 0
    }
  },
  methods: {
    async fetchData () {
      await this.$store.dispatch('earlyPayment/getCurrent', this.contractNo).then((result) => {
        if (result.Car && result.Car.BrandLogo !== '') {
          this.$bus.$emit('changeBrandLogo', result.Car.BrandLogo)
        }
        let date = new Date().toISOString()
        if (result.Is5050Contract === false) {
          date = result.NextDueDate
        }
        this.calculateEarlyPayment(date)
      })
    },
    calculateEarlyPayment (date) {
      EarlyPaymentService.calculateEarlyPaymentAll(this.contractNo, date).then((result) => {
        this.paymentAll = result.data.data
      })
    },
    calculateEarlyPaymentPrincipalReduce () {
      this.isRequest = true
      let date = this.interestDatePart.toISOString()
      if (this.earlyPayment.Is5050Contract === false) {
        date = this.earlyPayment.NextDueDate
      }
      EarlyPaymentService.calculateEarlyPaymentPrincipalReduce(this.contractNo, date, this.amount).then((result) => {
        if (result.data.data) {
          this.paymentPart = result.data.data
        } else {
          this.$store.commit('toast/NEW', { type: 'error', message: result.data.Message })
        }
        this.isRequest = false
      }).catch((error) => {
        this.isRequest = false
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      })
    }
  },
  created () {
    this.fetchData()
    EarlyPaymentService.getEarlyPaymentNote(this.contractNo, false).then(response => {
      this.paymentPartNote = response.data.data
    })

    EarlyPaymentService.getEarlyPaymentNote(this.contractNo, true).then(response => {
      this.paymentAllNote = response.data.data
    })
  },
  destroyed () {
    this.$bus.$emit('changeBrandLogo')
  }
}
</script>

<style lang="scss">
  @import '@/scss/components/_paymentPrice.scss';
  @import '@/scss/components/_payback.scss';
</style>

<style lang="css" scoped>
  @import '../../assets/css/tippy-border.css';
</style>
